import type {
	SlashCommandDefinition,
	SlashCommandSuggestionImpl,
} from "@/components/editor/extensions/slash-commands/types"
import {
	bulletedListCommand,
	checklistCommand,
	codeBlockCommand,
	dividerCommand,
	heading1Command,
	heading2Command,
	heading3Command,
	numberedListCommand,
	quoteCommand,
} from "@/components/editor/extensions/slash-commands/commands"
import { suggestion as baseSuggestion } from "@/components/editor/extensions/slash-commands/suggestion"

// Everything Linear renders in an issue description. Media commands are left out;
// images go in by paste or drop.
const issueSlashCommandItems: SlashCommandDefinition[] = [
	heading1Command,
	heading2Command,
	heading3Command,
	checklistCommand,
	numberedListCommand,
	bulletedListCommand,
	quoteCommand,
	codeBlockCommand,
	dividerCommand,
]

export const issueDescriptionSuggestion: SlashCommandSuggestionImpl = {
	items: ({ query }) => {
		const lowerQuery = query.toLocaleLowerCase()
		return issueSlashCommandItems.filter((item) => {
			const titleMatch = item.title.toLocaleLowerCase().includes(lowerQuery)
			const aliasMatch = item.aliases?.some((alias) =>
				alias.toLocaleLowerCase().includes(lowerQuery),
			)
			return titleMatch || aliasMatch
		})
	},
	render: baseSuggestion.render,
}
